module.exports = __webpack_public_path__ + "img/tiktok-icon.9f4515d4.svg";